var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import { Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service.ts";
import { ApplyType, MENU_CHANNEL } from "~/config/enum.config";
import LetterPrint from "~/components/collection-execution/collection-add-list/letter-print.vue";
import AddAddress from "../collection-add-list/add-address.vue";
import AssistApply from "~/components/apply-component/assist-apply.vue";
var CollectionExecutionModule = namespace("collection-execution");
var AddressList = /** @class */ (function (_super) {
    __extends(AddressList, _super);
    function AddressList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.applyType = ApplyType.assist;
        _this.searchModel = {};
        _this.dataSet = [];
        _this.dialog = {
            apply: false,
            letterPrint: false,
            addAddress: false
        };
        _this.rowData = {};
        return _this;
    }
    Object.defineProperty(AddressList.prototype, "showAssistButton", {
        get: function () {
            // 只有电催个人，电催团队才可以申请外访
            var s = [MENU_CHANNEL.Tel_personal, MENU_CHANNEL.Tel_team];
            return s.includes(this.menuChannel);
        },
        enumerable: false,
        configurable: true
    });
    AddressList.prototype.addressClick = function (scope) {
        this.rowData = scope.row;
        if (scope.row.applyStatus === null) {
            this.dialog.apply = true;
        }
        else {
            this.$message.warning("此案件的协催申请正在审核中，不允许重复申请！");
        }
    };
    /**
     * 新增地址
     */
    AddressList.prototype.addAddressClick = function () {
        this.dialog.addAddress = true;
    };
    //获取电催行动历史
    AddressList.prototype.refreshData = function () {
        var _this = this;
        this.searchModel.caseId = this.caseId;
        this.caseOperatorPageService
            .queryPersonalAddress(this.searchModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    AddressList.prototype.letterClick = function () { };
    AddressList.prototype.activated = function () {
        this.refreshData();
    };
    __decorate([
        Dependencies(PageService)
    ], AddressList.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], AddressList.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], AddressList.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], AddressList.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], AddressList.prototype, "hiddenAction", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], AddressList.prototype, "menuChannel", void 0);
    AddressList = __decorate([
        Component({
            components: {
                AddAddress: AddAddress,
                LetterPrint: LetterPrint,
                AssistApply: AssistApply
            }
        })
    ], AddressList);
    return AddressList;
}(Vue));
export default AddressList;
